import ApplianceService from '../../service/ApplianceService';

class Appliances {
  constructor() {
    this.appliances = [];
    this.appliance = null;
    this.deviceTwin = null;
    this.labs = [];
    this.lab = null;
  }
}

// initial state
const state = () => (new Appliances());

// getters
const getters = {

  appliances:(state) => {
      return state.appliances;
  },

  appliance:(state) => (serialNumber) => {
    if(state.appliance && state.appliance.serialNumber == serialNumber) {
      return state.appliance;
    }
    for(let i=0; i<state.appliances.length; i++) {
      if(state.appliances[i].serialNumber == serialNumber) {
        return state.appliances[i];
      }
    }
    return {};
  },

  deviceTwin:(state) => {
    return state.deviceTwin;
  },

  labs:(state) => {
      return state.labs;
  },

  lab:(state) => (labId) => {
    if(state.lab && state.lab.id == labId) {
      return state.lab;
    }
    for(let i=0; i<state.labs.length; i++) {
      if(state.labs[i].id == labId) {
        return state.labs[i];
      }
    }
    return {};
  }
}

// actions
const actions = {

  websocket({ commit }, msg) {
    let serialNumber = msg.serialNumber;
    let upd = { 
      serialNumber: serialNumber,
      data: {},
      alarms: null
    };
    let updDT = { 
      serialNumber: serialNumber,
      data: {},
      alarms: null
    };

    //REPORTED
    if(typeof(msg.reported) != "undefined") {
      updDT.data.status = msg.reported;
      commit('updateDeviceTwinStatus', updDT);
      if(msg.reported.cycleRunning!=null) {
        upd.data.cycleRunning = msg.reported.cycleRunning;
        commit('updateAppliance', upd);
      }
      return;
    }

    //TELEMETRY
    if(typeof(msg.online) != "undefined") {
      upd.data.online = msg.online;
    }
    if(typeof(msg.status) != "undefined") {
      upd.data.status = msg.status;
    }
    if(typeof(msg.cycle) != "undefined") {
      upd.data.cycle = msg.cycle;
    }
    if(typeof(msg.warnings) != "undefined") {
      upd.data.warnings = msg.warnings;
    }
    if(typeof(msg.alarms) != "undefined") {
      upd.alarms = msg.alarms; //This need update logic!!!
    }
    commit('updateAppliance', upd);
  },

}

// mutations
const mutations = {

  appliances(state, payload) {
    state.appliance = null;
    if(Array.isArray(payload)) {
      state.appliances = payload;
    } else {
      state.appliances = [];
    }
  },  

  labs(state, payload) {
    state.lab = null;
    state.labs = payload;
  },  

  applianceDetails(state, payload) {
    state.appliance = payload;
  },

  updateAppliance(state, payload) {
    if(state.appliance && state.appliance.serialNumber == payload.serialNumber) {
      state.appliance = {...state.appliance, ...payload.data}; //Update appliance
      //Alarms stuff
      if(payload.alarms) {
        if(state.appliance.alarms == null) {
          state.appliance.alarms = [];
        }
        payload.alarms.forEach(alarm => {
          if(alarm.active===false) { //If alarm is not active, then deactivate all previous alarms (with same name)
            for(let i=0; i<state.appliance.alarms.length; i++) {
              if(state.appliance.alarms[i].name == alarm.name) {
                state.appliance.alarms[i].active = false;
              }
            }
          } else { //If alarm is active, then add it to the alarms
            state.appliance.alarms.push(alarm);
          }
        });
      }
    }
    for(let i=0; i<state.appliances.length; i++) {
      let a = state.appliances[i];
      if(a.serialNumber == payload.serialNumber) {
        a = {...a, ...payload.data}; //Update appliance in appliances
        //Alarms stuff
        if(payload.alarms) {
          if(a.alarms == null) {
            a.alarms = [];
          }
          payload.alarms.forEach(alarm => {
            if(alarm.active===false) { //If alarm is not active, remove all previous alarms (with same name)
              for(let i=0; i<a.alarms.length; i++) {
                if(a.alarms[i].name == alarm.name) {
                  a.alarms.splice(i,1);
                  i--;
                }
              }
            } else { //If alarm is active, then add it to the alarms
              a.alarms.push(alarm);
            }
          });
        }
        state.appliances[i] = a;
        break;
      }
    }
  },

  deviceTwin(state, payload) {
    state.deviceTwin = payload;
  },

  updateDeviceTwinStatus(state, payload) {
    if(state.deviceTwin && state.deviceTwin.serialNumber == payload.serialNumber) {
      state.deviceTwin.status = {...state.deviceTwin.status, ...payload.data.status}; //Update device twin reported
    }
  },

  offline(state) { //This is only for testing/devolop purposes... delete it when developments are terminated!!!!
    for(let i=0; i<state.appliances.length; i++) {
      state.appliances[i].online = false;
    }
  },

}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  created() {
    this.applianceService = new ApplianceService();
  }
}
